/**
 * Promote-specific permission types.
 */
export enum PromotePermission {
  CAMPAIGNS_VIEW = 'CAMPAIGNS_VIEW',
  CAMPAIGNS_CREATE = 'CAMPAIGNS_CREATE',
  CAMPAIGNS_EDIT = 'CAMPAIGNS_EDIT',
  CAMPAIGNS_DELETE = 'CAMPAIGNS_DELETE',
  CAMPAIGNS_APPROVE = 'CAMPAIGNS_APPROVE',
  ACCOUNTS_VIEW = 'ACCOUNTS_VIEW',
  ACCOUNTS_MANAGE = 'ACCOUNTS_MANAGE',
  ANALYTICS_VIEW = 'ANALYTICS_VIEW',
  SETTINGS_VIEW = 'SETTINGS_VIEW',
  SETTINGS_MANAGE = 'SETTINGS_MANAGE',
  ADMIN_ACCESS = 'ADMIN_ACCESS',
}

/**
 * Union type for all permission strings.
 */
export type Permission = `${PromotePermission}`;
